import { gql } from '@apollo/client';

export const RETRY_FAILED_OUTBOUND_SUBSCRIPTION = gql`
  subscription retryFailedOutbound {
    retryFailedOutbound {
      id
      updatedDate
    }
  }
`;
export const TOOL_HOUND_OUTBOUND_SUBSCRIPTION = gql`
  subscription ToolHoundOutBound {
    toolHoundOutBound {
      referenceId
    }
  }
`;
export const TOOL_ORDER_INVENTORY_UPDATED_SUBSCRIPTION = gql`
  subscription inventoryUpdated {
    inventoryUpdated {
      toolInventoryIds
      updatedDate
      toolRoomId
    }
  }
`;
export const TOOL_ORDER_UPDATED_SUBSCRIPTION = gql`
  subscription ToolOrderUpdated {
    toolOrderUpdated {
      id
      toolRoomId
      toolOrderStatus
      updatedDate
    }
  }
`;

export const TOOL_ORDER_CREATED_SUBSCRIPTION = gql`
  subscription ToolOrderCreated {
    toolOrderCreated {
      id
      toolRoomId
      toolOrderStatus
      createdDate
    }
  }
`;
